<template>
    <div class="geo" v-can="'settings_geo.access'">
        <ds-table
            :data="geosMap"
            :heads="heads"
            :max-items="geosMap.length"
            :paginate="false"
            spacer
        >
            <template v-slot:header>
                <vs-button
                    @click="addGeo(null)"
                    class="mr-4"
                    color="primary"
                    type="border"
                    v-bind="$iconData('icon-plus', 'fi-rr-plus')"
                    v-can="'settings_geo.create'"
                >
                    {{ $t('buttons.Add_geo') }}
                </vs-button>
            </template>

            <template v-slot:country="{country}">
                <vs-chip v-tooltip.left-end="country.country.join('<br>')">
                    <vs-avatar color="#f0f0f0" text-color="#175ea5" v-bind="$iconData('icon-map-pin', 'fi-rr-marker')"></vs-avatar>
                    <span>{{ country.countryLength }}</span>
                </vs-chip>
            </template>

            <template v-slot:languages="{languages}">
                <vs-chip v-tooltip.left-end="languages.languageView.join('<br>')">
                    <vs-avatar color="#f0f0f0" text-color="#175ea5" v-bind="$iconData('icon-globe', 'fi-rr-globe')"></vs-avatar>
                    <span>{{ languages.languageLength }}</span>
                </vs-chip>
            </template>

            <template v-slot:actions="{actions}">
                <vs-button @click="editGeo(actions)"
                           v-tooltip="$t('modals.Edit_geo')"
                           class="mr-3"
                           radius
                           color="primary"
                           type="flat"
                           v-bind="$iconData('icon-edit', 'fi-rr-file-edit')"
                ></vs-button>
            </template>
        </ds-table>
    </div>
</template>


<script>
import {mapActions, mapGetters} from 'vuex'
import EventBus from '../../../store/eventBus'
import ErrorHandler from '@/utils/errorHandler'

export default {
    data() {
        return {
            heads: [
                {name: 'global.Name', key: 'geo_name', sortKey: 'geo_name', value: 'geo_name', display: true},
                {name: 'global.Country', key: 'country', sortKey: 'countryLength', value: 'country', display: true},
                {name: 'global.Languages', key: 'languages', sortKey: 'languageLength', value: 'languages', display: true},
                {name: 'global.Actions', key: 'actions', value: 'actions', can: 'settings_geo.update', display: true},
            ]
        }
    },

    computed: {
        ...mapGetters(['geo', 'geosMap'])
    },

    methods: {
        ...mapActions(['GET_GEOS']),

        addGeo() {
            EventBus.$emit('emitPopupEvent', {
                type: 'addGeo',
                name: this.$t('buttons.Add_geo'),
                ids: {}
            })
        },

        editGeo(data) {
            EventBus.$emit('emitPopupEvent', {
                type: 'editGeo',
                name: this.$t('modals.Edit_geo'),
                ids: {data}
            })
        }
    },

    async mounted() {
        try {
            await this.GET_GEOS()
        } catch(e) {
            new ErrorHandler(e).send
        }
    }
}
</script>


